import { render, staticRenderFns } from "./Mocard.vue?vue&type=template&id=80750984&"
import script from "./Mocard.vue?vue&type=script&lang=js&"
export * from "./Mocard.vue?vue&type=script&lang=js&"
import style0 from "./Mocard.vue?vue&type=style&index=0&id=80750984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports